import React from 'react';
import { Button } from '@insticator/insticator-ui'
import injectSheet from 'react-jss';
import styles from './modal_styles';

const ScrollWithAdsModal = injectSheet(styles)((props) => {
    return (
        <div className={`${props.classes.modal}`}>
            <div className='content'>
                Please reach out to your account manager and let him/her know
                your interest in having an ad alongside the article. For now,
                only the Flat and Scroll view are available for production.
            </div>
            <Button
                type={'action'}
                variant={'primary'}
                text={'OK'}
                action={props.closeModal}/>
        </div>
    )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ScrollWithAdsModal;
